// assets/discount-drawer.js
(function () {
  if (window.__KEA_DISCOUNT_DRAWER_BOUND__) return;
  window.__KEA_DISCOUNT_DRAWER_BOUND__ = true;

  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  const JSON_HEADERS = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  const getDrawer = () =>
    document.getElementById("mini-cart") || document.querySelector("cart-drawer");

  const cartGet = () =>
    fetch(ROOT + "cart.js", { credentials: "same-origin" }).then((r) => r.json());

  async function applyCodes(csv) {
    let res = await fetch(ROOT + "cart/update.js", {
      method: "POST",
      headers: JSON_HEADERS,
      credentials: "same-origin",
      body: JSON.stringify({ discount: csv }),
    });

    if (!res.ok) {
      res = await fetch(ROOT + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          Accept: "application/json",
        },
        credentials: "same-origin",
        body: "discount=" + encodeURIComponent(csv),
      });
    }

    try {
      return await res.json();
    } catch (e) {
      return null;
    }
  }

  function getPromoConfig() {
    const drawer = getDrawer();
    const promoEnabled =
      !!drawer &&
      String(drawer.dataset.promoEnabled || "").toLowerCase() === "true";

    if (!promoEnabled) {
      return { promoEnabled: false, PROMO_MAP: {}, TRIGGER_CODES: [] };
    }

    let codes = [];
    try {
      if (drawer.dataset.promoCode) {
        codes = JSON.parse(drawer.dataset.promoCode);
      }
    } catch (e) {
      console.warn("[discount-drawer] unable to parse data-promo-code", e);
    }

    const promoVariantId = drawer.dataset.promoVariantId
      ? Number(drawer.dataset.promoVariantId)
      : 0;

    const PROMO_MAP = {};
    if (codes.length && promoVariantId) {
      codes.forEach((c) => {
        if (!c) return;
        PROMO_MAP[String(c).toUpperCase()] = promoVariantId;
      });
    }

    return {
      promoEnabled: true,
      PROMO_MAP,
      TRIGGER_CODES: Object.keys(PROMO_MAP),
    };
  }

  async function addVariant(variantId, props) {
    if (!variantId) return;

    const res = await fetch(ROOT + "cart/add.js", {
      method: "POST",
      headers: JSON_HEADERS,
      credentials: "same-origin",
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1,
            properties: props || {},
          },
        ],
      }),
    });

    if (!res.ok) {
      let payload = null;
      try {
        payload = await res.json();
      } catch (_) {}
      console.warn("[discount-drawer] addVariant failed", res.status, payload);
    }
  }

  async function changeByKey(key, quantity) {
    if (!key) return;

    const res = await fetch(ROOT + "cart/change.js", {
      method: "POST",
      headers: JSON_HEADERS,
      credentials: "same-origin",
      body: JSON.stringify({ id: key, quantity }),
    });

    if (!res.ok) {
      console.warn("[discount-drawer] changeByKey failed", res.status);
    }
  }

  function extractDiscountCodes(cart) {
  const set = new Set();

  (cart.cart_level_discount_applications || []).forEach((a) => {
    if ((a.type || "") === "discount_code" && a.title) {
      set.add(String(a.title).toUpperCase());
    }
  });

  (cart.discount_applications || []).forEach((a) => {
    if ((a.type || "") === "discount_code" && a.title) {
      set.add(String(a.title).toUpperCase());
    }
  });

  (cart.items || []).forEach((li) => {
    const allocations =
      li.line_level_discount_allocations ||
      li.discount_allocations ||
      [];

    allocations.forEach((alloc) => {
      const app = alloc.discount_application || {};
      if ((app.type || "") === "discount_code" && app.title) {
        set.add(String(app.title).toUpperCase());
      }
    });
  });

  return Array.from(set);
}


  function parseInputCodes(raw) {
    return String(raw || "")
      .split(/[,\s]+/g)
      .map((s) => s.trim())
      .filter(Boolean)
      .map((s) => s.toUpperCase());
  }

  async function refreshDrawer() {
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", { bubbles: true }),
    );

    const drawer = getDrawer();
    const sid = drawer?.dataset?.sectionId || drawer?.getAttribute("section");
    if (!sid) return;

    const ids = [sid, "cart-icon-bubble"];

    try {
      const res = await fetch(`${ROOT}?sections=${ids.join(",")}`, {
        credentials: "same-origin",
      });
      if (!res.ok) return;

      const html = await res.json();

      ids.forEach((id) => {
        const host =
          document.getElementById("shopify-section-" + id) ||
          document.querySelector(`[data-section-id="${id}"]`);
        if (host && html[id]) host.innerHTML = html[id];
      });
    } catch (e) {
      console.warn("[discount-drawer] refreshDrawer error", e);
    }
  }

  function keaFireworksAtElement(el) {
    if (!el || !el.getBoundingClientRect) return;

    const rect = el.getBoundingClientRect();
    const x = rect.left + rect.width / 2;
    const y = rect.top + rect.height / 2;

    const container = document.createElement("div");
    container.className = "kea-fireworks-container";
    container.style.position = "fixed";
    container.style.inset = "0";
    container.style.pointerEvents = "none";
    container.style.zIndex = "99999";
    container.style.overflow = "visible";
    document.body.appendChild(container);

    const colors = ["#ff6b6b", "#feca57", "#48dbfb", "#5f27cd", "#1dd1a1", "#ffffff"];
    const particleCount = 64;

    const flash = document.createElement("div");
    flash.style.position = "absolute";
    flash.style.left = x + "px";
    flash.style.top = y + "px";
    flash.style.width = "24px";
    flash.style.height = "24px";
    flash.style.borderRadius = "999px";
    flash.style.background = "rgba(255,255,255,0.95)";
    flash.style.transform = "translate(-50%, -50%) scale(0)";
    flash.style.opacity = "0.9";
    flash.style.boxShadow = "0 0 40px rgba(255,255,255,0.9)";
    flash.style.transition = "transform 260ms ease-out, opacity 360ms ease-out";
    container.appendChild(flash);

    requestAnimationFrame(() => {
      flash.style.transform = "translate(-50%, -50%) scale(3.2)";
      flash.style.opacity = "0";
    });

    for (let i = 0; i < particleCount; i++) {
      const particle = document.createElement("span");

      const angle = Math.random() * Math.PI * 2;
      const ring = Math.random() < 0.5 ? 1 : 2;
      const baseDistance = ring === 1 ? 90 : 150;
      const distance = baseDistance + Math.random() * 40;

      const dx = Math.cos(angle) * distance;
      const dy = Math.sin(angle) * distance;

      particle.style.position = "absolute";
      particle.style.left = x + "px";
      particle.style.top = y + "px";
      particle.style.width = "10px";
      particle.style.height = "10px";
      particle.style.borderRadius = "999px";
      particle.style.backgroundColor = colors[i % colors.length];
      particle.style.opacity = "1";
      particle.style.transform = "translate(-50%, -50%) translate(0, 0)";
      particle.style.boxShadow =
        "0 0 14px rgba(0,0,0,0.25), 0 0 18px rgba(255,255,255,0.6)";
      particle.style.transition =
        "transform 1100ms cubic-bezier(0.16, 0.84, 0.44, 1), opacity 1100ms ease-out";

      container.appendChild(particle);

      requestAnimationFrame(() => {
        const gravity = 35 + Math.random() * 25;
        particle.style.transform = `translate(-50%, -50%) translate(${dx}px, ${dy + gravity}px)`;
        particle.style.opacity = "0";
      });
    }

    setTimeout(() => container.remove(), 1300);
  }

  // ========= SUBMIT: APPLY DISCOUNT(S) =========
  document.addEventListener("submit", async (ev) => {
    const form = ev.target.closest("#drawer-discount-form");
    if (!form) return;

    ev.preventDefault();

    const input = form.querySelector("#drawer-discount-input");
    const feedback = document.getElementById("drawer-discount-feedback");

    const raw = (input?.value || "").trim();
    const submittedCodes = parseInputCodes(raw);

    if (!submittedCodes.length) {
      if (feedback) {
        feedback.textContent = "Entrez un code";
        feedback.style.color = "#b42318";
      }
      return;
    }

    const applyButton = form.querySelector('button[type="submit"]');

    try {
      const before = await cartGet();
      const existing = extractDiscountCodes(before);

      const set = new Set(existing);
      submittedCodes.forEach((c) => set.add(c));

      const csv = Array.from(set).join(",");
      const after = (await applyCodes(csv)) || (await cartGet());
      const applied = extractDiscountCodes(after);

      // OPTIONAL: ancien mapping code -> cadeau (si promoEnabled)
      const promoCfg = getPromoConfig();
      if (promoCfg.promoEnabled && promoCfg.TRIGGER_CODES.length) {
        for (const c of submittedCodes) {
          if (!promoCfg.TRIGGER_CODES.includes(c)) continue;
          if (!applied.includes(c)) continue;

          const variantId = promoCfg.PROMO_MAP[c];
          const already = (after.items || []).some((li) => {
            const p = li.properties || {};
            return (
              li.id === variantId &&
              String(p._promo_code || p["_promo_code"] || "").toUpperCase() === c
            );
          });

          if (!already) {
            await addVariant(variantId, { _promo_code: c });
          }
        }
      }

      const allApplied = submittedCodes.every((c) => applied.includes(c));

      if (feedback) {
        if (allApplied) {
          feedback.textContent = form.dataset.i18nApplied || "Code appliqué";
          feedback.style.color = "";
        } else {
          feedback.textContent =
            form.dataset.i18nInvalid || "Code invalide ou non cumulable";
          feedback.style.color = "#b42318";
        }
      }

      if (input) input.value = "";

      if (applyButton) keaFireworksAtElement(applyButton);

      await refreshDrawer();
    } catch (e) {
      console.warn("[discount-drawer] submit error", e);
      if (feedback) {
        feedback.textContent = "Erreur, merci de réessayer.";
        feedback.style.color = "#b42318";
      }
    }
  });

  // ========= CLICK: REMOVE ONE DISCOUNT CODE =========
  document.addEventListener("click", async (ev) => {
    const btn = ev.target.closest('[data-action="remove-discount"]');
    if (!btn) return;

    const removed = String(btn.dataset.code || "").trim().toUpperCase();
    if (!removed) return;

    try {
      const cart = await cartGet();
      const existing = extractDiscountCodes(cart);
      const keep = existing.filter((c) => c !== removed);

      await applyCodes(keep.join(","));

      // OPTIONAL: si promoEnabled, retirer les gifts _promo_code == removed
      const promoCfg = getPromoConfig();
      if (promoCfg.promoEnabled && promoCfg.TRIGGER_CODES.includes(removed)) {
        const fresh = await cartGet();
        const gifts = (fresh.items || []).filter((li) => {
          const p = li.properties || {};
          const code = String(p._promo_code || p["_promo_code"] || "").toUpperCase();
          return code === removed;
        });

        for (const g of gifts) {
          await changeByKey(g.key, 0);
        }
      }

      await refreshDrawer();
    } catch (e) {
      console.warn("[discount-drawer] remove error", e);
    }
  });
})();